import httpClient from "./httpClient";
import qs from "qs";
import type { ApiResponse } from "../types/api";

export default class LogApi {
  static createOne(slug: string, tokenAdmin: string | null = null): Promise<ApiResponse> {
    return httpClient
      .post(
        API_URL + "/log",
        qs.stringify({
          slug,
          token_admin: tokenAdmin,
        })
      )
      .then((response) => response.data);
  }
}
